// extracted by mini-css-extract-plugin
export var LabCTA = "LabCTA-module--LabCTA--rUe5d";
export var hidden = "LabCTA-module--hidden--3uoJj";
export var isShowingHint = "LabCTA-module--isShowingHint--Pa-Lr";
export var isLabTransitionRunning = "LabCTA-module--isLabTransitionRunning--umur8";